import React, { useEffect, useState, useRef } from "react";
import { secretKey } from "../.././data";
import LoadingPopup from "../helpers/loading_component.js";
import { faEdit, faEye, faDeleteLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
const MySwal = withReactContent(Swal2);

const AdminPanelMSAPI = (props) => {
  const [banks, setBanks] = useState([]);
  const [actual, setActual] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [lawsuits, setLawsuits] = useState([]);
  var [url, setUrl] = useState(["portal.waw.sa.gov.pl"]);
  const [sygns, setSygns] = useState([]);

  const getData = () => {
    setLoading(true);
    fetchSygns();
  };

  useEffect(() => {
    getData();
  }, []);

  const fetchSygns = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getClientsSygnV", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setSygns(data);
        setLoading(false);
        //getLawsuits();

        var arr = [
          "portal.bialystok.sa.gov.pl",
          "portal.gdansk.sa.gov.pl",
          "portal.katowice.sa.gov.pl",
          "portal.krakow.sa.gov.pl",
          "portal.lublin.sa.gov.pl",
          "portal.lodz.sa.gov.pl",
          "portal.poznan.sa.gov.pl",
          "portal.rzeszow.sa.gov.pl",
          "portal.szczecin.sa.gov.pl",
          "portal.waw.sa.gov.pl",
          "portal.wroclaw.sa.gov.pl",
        ];
      })
      .catch((error) => {});
  };

  const getLawsuits = (e) => {
    var ls = [];

    var pages = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    url.map((link) => {
      pages.map((page) => {
        var url = "https://apidevkppp.ftpeople.pl/authToken";
        fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((response) => response.json())
          .then(async (data) => {
            var token = data.id_token;

            var body = {
              token: token,
              url: "https://" + link,
              page: page,
            };

            var url = "https://apidevkppp.ftpeople.pl/getLawsuits";
            await fetch(url, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
              },
              body: JSON.stringify(body),
            })
              .then((response) => response.json())
              .then((data) => {
                var array = data;
                ls = ls.concat(array);

                setLawsuits(ls);
              })
              .catch((error) => {});
          })
          .catch((error) => {});
      });
    });
  };

  const getRepertories = () => {
    var url = "https://apidevkppp.ftpeople.pl/authToken";
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then(async (data) => {
        var token = data.id_token;

        var body = {
          token: token,
          url: "https://portal.waw.sa.gov.pl/api/repertories",
        };

        var url = "https://apidevkppp.ftpeople.pl/getAPIMSDataGET";
        await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});
      })
      .catch((error) => {});
  };

  const getRoles = () => {
    var url = "https://apidevkppp.ftpeople.pl/authToken";
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then(async (data) => {
        var token = data.id_token;

        var body = {
          token: token,
          url: "https://portal.waw.sa.gov.pl/api/roles",
        };

        var url = "https://apidevkppp.ftpeople.pl/getAPIMSDataGET";
        await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});
      })
      .catch((error) => {});
  };

  const getDict = () => {
    var url = "https://apidevkppp.ftpeople.pl/authToken";
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then(async (data) => {
        var token = data.id_token;

        var body = {
          token: token,
          url: "https://portal.waw.sa.gov.pl/api/dictionaries",
        };

        var url = "https://apidevkppp.ftpeople.pl/getAPIMSDataGET";
        await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});
      })
      .catch((error) => {});
  };

  const getDashboard = () => {
    var url = "https://apidevkppp.ftpeople.pl/authToken";
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then(async (data) => {
        var token = data.id_token;

        var body = {
          token: token,
          url: "https://portal.waw.sa.gov.pl/api/dashboard/lawsuits",
        };

        var url = "https://apidevkppp.ftpeople.pl/getAPIMSDataGET";
        await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});
      })
      .catch((error) => {});
  };

  const getLawId = () => {
    var url = "https://apidevkppp.ftpeople.pl/authToken";
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then(async (data) => {
        var token = data.id_token;

        var body = {
          token: token,
          url: "https://portal.waw.sa.gov.pl/api/lawsuits/" + "14203055" + "",
        };

        var url = "https://apidevkppp.ftpeople.pl/getAPIMSDataGET";
        await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {
            getLawId2();
          })
          .catch((error) => {});
      })
      .catch((error) => {});
  };

  const getLawId2 = () => {
    var url = "https://apidevkppp.ftpeople.pl/authToken";
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then(async (data) => {
        var token = data.id_token;

        var body = {
          token: token,
          url:
            "https://portal.waw.sa.gov.pl/api/parties/lawsuit?page=0&size=20&lawsuitId.equals=" +
            "14203055" +
            "",
        };

        var url = "https://apidevkppp.ftpeople.pl/getAPIMSDataGET";
        await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {
            getLawId3();
          })
          .catch((error) => {});
      })
      .catch((error) => {});
  };

  const getLawId3 = () => {
    var url = "https://apidevkppp.ftpeople.pl/authToken";
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then(async (data) => {
        var token = data.id_token;

        var body = {
          token: token,
          url:
            "https://portal.waw.sa.gov.pl/api/proceedings/lawsuit?lawsuitId.equals=" +
            "14203055" +
            "",
        };

        var url = "https://apidevkppp.ftpeople.pl/getAPIMSDataGET";
        await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {
            getLawId4();
          })
          .catch((error) => {});
      })
      .catch((error) => {});
  };

  const getLawId4 = () => {
    var url = "https://apidevkppp.ftpeople.pl/authToken";
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then(async (data) => {
        var token = data.id_token;

        var body = {
          token: token,
          url:
            "https://portal.waw.sa.gov.pl/api/relations?page=0&size=200&lawsuitId.equals=14203055" +
            "&sort=id,asc",
        };

        var url = "https://apidevkppp.ftpeople.pl/getAPIMSDataGET";
        await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});
      })
      .catch((error) => {});
  };

  const getLawId5 = () => {
    var url = "https://apidevkppp.ftpeople.pl/authToken";
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then(async (data) => {
        var token = data.id_token;

        var body = {
          token: token,
          url: "https://portal.waw.sa.gov.pl/api/lawsuits/" + "10993996" + "",
        };

        var url = "https://apidevkppp.ftpeople.pl/getAPIMSDataGET";
        await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});
      })
      .catch((error) => {});
  };

  const getDeliveries = () => {
    var url = "https://apidevkppp.ftpeople.pl/authToken";
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then(async (data) => {
        var token = data.id_token;

        var body = {
          token: token,
          url:
            "https://portal.waw.sa.gov.pl/api/deliveries?signature.equals=" +
            encodeURI("I ACa 438/23") +
            "",
        };

        var url = "https://apidevkppp.ftpeople.pl/getAPIMSDataGET";
        await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});
      })
      .catch((error) => {});
  };

  const getDeliveriesId = () => {
    var url = "https://apidevkppp.ftpeople.pl/authToken";
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then(async (data) => {
        var token = data.id_token;

        var body = {
          token: token,
          url: "https://portal.waw.sa.gov.pl/api/deliveries/2222837/documents",
        };

        var url = "https://apidevkppp.ftpeople.pl/getAPIMSDataGET";
        await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});
      })
      .catch((error) => {});
  };

  const getNotifications = () => {
    var url = "https://apidevkppp.ftpeople.pl/authToken";
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then(async (data) => {
        var token = data.id_token;

        var body = {
          token: token,
          url: "https://portal.waw.sa.gov.pl/api/notifications",
        };

        var url = "https://apidevkppp.ftpeople.pl/getAPIMSDataGET";
        await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});
      })
      .catch((error) => {});
  };

  const getConnected = () => {
    var ret = 0;
    lawsuits.map((el) => {
      sygns.filter((el2) => el2.sygns.includes(el.signature)).length > 0
        ? (ret = ret + 1)
        : (ret = ret);
    });

    return ret;
  };

  const getNotConnected = () => {
    var ret = 0;
    lawsuits.map((el) => {
      sygns.filter((el2) => el2.sygns.includes(el.signature)).length > 0
        ? (ret = ret)
        : (ret = ret + 1);
    });

    return ret;
  };

  const lawData = (
    <>
      {lawsuits.length > 0 ? (
        <>
          <div style={{ marginBottom: "1vh" }}>
            <div style={{ height: "3vh" }}></div>
            <div style={{ height: "3vh" }}></div>
            <div>
              <p>Ilosć spraw: {lawsuits.length}</p>
              <p>Ilosć powiązanych: {getConnected()}</p>
              <p>Ilosć niepowiązanych: {getNotConnected()}</p>
              <table className="clients_table">
                <tr>
                  <th>Identyfikator</th>
                  <th>Sąd</th>
                  <th>Sygnatura</th>
                  <th>Temat</th>
                  <th>Powodowie</th>
                  <th>ID KLIENTA</th>
                </tr>

                {lawsuits.map((el) => (
                  <tr>
                    <td>{el.id}</td>
                    <td>{el.courtName}</td>
                    <td>{el.signature}</td>
                    <td>{el.subject}</td>
                    <td>
                      {el.lawsuitParties
                        .filter((el) => el.type === "R")
                        .map(
                          (el2, index) =>
                            el2.name +
                            " " +
                            el2.type +
                            (index + 1 === el.lawsuitParties.length ? "" : ",")
                        )}
                    </td>
                    <td>
                      {sygns.filter((el2) => el2.sygns.includes(el.signature))
                        .length > 0
                        ? sygns.filter((el2) =>
                            el2.sygns.includes(el.signature)
                          )[0].id
                        : "nie powiązano"}
                    </td>
                  </tr>
                ))}
              </table>
            </div>
          </div>
        </>
      ) : (
        ""
      )}
    </>
  );

  return (
    <>
      <div className="mainContainerPayments">
        {loading ? (
          <>
            <LoadingPopup />
          </>
        ) : (
          <>
            <div
              style={{ width: "100%", marginBottom: "1vh" }}
              className="closeBox"
            >
              <button className="closeClientButton" onClick={props.close}>
                X
              </button>
            </div>
            <button className="paymentMenuButton" onClick={getLawsuits}>
              Pobierz sprawy
            </button>
            <div style={{ display: "block" }}>{lawData}</div>
            <div>
              <button className="paymentMenuButton" onClick={getRepertories}>
                Pobierz repetytoria
              </button>
            </div>
            <div>
              <button className="paymentMenuButton" onClick={getRoles}>
                Pobierz role
              </button>
            </div>
            <div>
              <button className="paymentMenuButton" onClick={getDict}>
                Pobierz słowniki
              </button>
            </div>
            <div>
              <button className="paymentMenuButton" onClick={getDashboard}>
                Pobierz dashboard
              </button>
            </div>
            <div>
              <button className="paymentMenuButton" onClick={getLawId}>
                Pobierz Sitek
              </button>
            </div>
            <div>
              <button className="paymentMenuButton" onClick={getNotifications}>
                Pobierz powiadomienia
              </button>
            </div>
            <div>
              <button className="paymentMenuButton" onClick={getDeliveries}>
                Pobierz doręczenia
              </button>
            </div>
            <div>
              <button className="paymentMenuButton" onClick={getDeliveriesId}>
                Pobierz dokument
              </button>
            </div>
            <div>
              <button className="paymentMenuButton" onClick={getLawId5}>
                Pobierz relacje z SITEK
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AdminPanelMSAPI;
